<template>
    <SbsTooltip
        position="top-end"
        content="Закрыть плеер">
        <SbsButtonIcon
            v-bind="closeButtonData"
            @click.stop="handleClose" />
    </SbsTooltip>
</template>

<script>
export default {
    name: 'AudioCloseBtn',
    emits: ['closePlayer'],
    computed: {
        closeButtonData() {
            return {
                height: '20',
                width: '20',
                iconName: 'close',
                colorTheme: 'gray',
                iconSize: 'large',
                hoverColor: 'gray-deep',
                backgroundTheme: 'transperant',
            };
        },
    },
    methods: {
        handleClose() {
            this.$emit('closePlayer', true);
        },
    },
};
</script>
